import styles from "../../styles/components/ContactDetailModal.module.css";

export function VerifiedMark({ emailAddress }) {
  return (
    <span
      className={styles.verifiedCheck}
      title="Email validado como entregable"
      aria-label={`Email ${emailAddress} validado`}
      role="img"
    >
      <svg viewBox="0 0 16 16" fill="none">
        <path
          d="M2.5 8.5l3.5 3.5 7.5-8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export function NotDeliverableMark({ emailAddress }) {
  return (
    <span
      className={styles.failedCheck}
      title="El email no es entregable"
      aria-label={`Email ${emailAddress} no entregable`}
      role="img"
    >
      <svg viewBox="0 0 16 16" fill="none">
        <path
          d="M3.5 3.5l9 9M12.5 3.5l-9 9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
